import React, { useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { deleteConversation } from 'container/api';
import ConfirmationModel from 'container/Dialogs/ConfirmationModel/ConfirmationModel';
// import Confirmation from 'container/Dialogs/Confirmation/Confirmation';

function ClearConversation() {
  const dispatch = useDispatch();
  const isOpen = useSelector(state => state.utils.isLeftSideBarOpen);
  const [open, setOpen] = useState(false);
  const { conversations, loading } = useSelector(state => state.chat);

  const handleClearConversations = async () => {
    try {
      await Promise.all(
        conversations.map(conversation => deleteConversation(conversation.id))
      );
      dispatch.chat.setSelectedConversation(null);
      dispatch.chat.setMessages([]);
      dispatch.chat.setConversations([]);
      dispatch.chat.getAllConversations();
    } catch (err) {
      console.log(err.message);
    }
  };
  if (!conversations.length) {
    return null;
  }
  return (
    <div
      className='clear-container cursor-pointer'
      onClick={() => {
        if (!loading) {
          setOpen(!open);
        }
      }}
      style={{
        width: isOpen ? '' : '60px',
        height: isOpen ? '' : '60px',
        display: isOpen ? '' : 'grid',
        placeItems: isOpen ? '' : 'center',
        cursor: loading ? 'not-allowed' : 'pointer',
      }}
    >
      {isOpen ? (
        <p
          className='main'
          style={{
            textAlign: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          Clear Conversations
        </p>
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='10'
          height='10'
          viewBox='0 0 10 10'
          fill='none'
          style={{
            width: isOpen ? '' : '18px',
            height: isOpen ? '' : '18px',
          }}
        >
          <path
            d='M9.77816 0.229428C9.48237 -0.0663631 9.00455 -0.0663631 8.70876 0.229428L5 3.9306L1.29124 0.221843C0.99545 -0.0739477 0.517634 -0.0739477 0.221843 0.221843C-0.0739477 0.517634 -0.0739477 0.99545 0.221843 1.29124L3.9306 5L0.221843 8.70876C-0.0739477 9.00455 -0.0739477 9.48237 0.221843 9.77816C0.517634 10.0739 0.99545 10.0739 1.29124 9.77816L5 6.0694L8.70876 9.77816C9.00455 10.0739 9.48237 10.0739 9.77816 9.77816C10.0739 9.48237 10.0739 9.00455 9.77816 8.70876L6.0694 5L9.77816 1.29124C10.0664 1.00303 10.0664 0.517634 9.77816 0.229428Z'
            fill='white'
          />
        </svg>
      )}
      {/* Clear Model */}
      <ConfirmationModel
        open={open}
        setOpen={() => setOpen(!open)}
        action={handleClearConversations}
        descripiton='Are you sure you want to delete this entire conversation?'
        btnText='Delete'
      />
    </div>
  );
}

export default ClearConversation;
